module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/ico_gradient/gold-ico-gradient-4292a0d62f41d58a136cd9bc4f2d5755.svg";